<template>
  <AgGridRenderList
    :columnDefs="columnDefs"
    :rowData="rowData"
    :totalRows="totalRows"
    :lastPage="lastPage"
    :loading="paginationLoading"
    @updatePagination="updatePagination"
    @updateItemPerPage="updateItemPerPage"
  />
</template>

<script>
import General from "../../../../../../../Mixins/general";
import AgvmenuCustom from "../../../../../components/general/AgGridComponents/Ag-vmenuCustom.vue";
import moment from "moment-jalaali";

export default {
  components: { AgvmenuCustom },
  props: {
    callRefresh: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      totalRows: null,
      lastPage: null,
      invoiceIds: null,
      filterDialog: false,
      toDate: null,
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      account: null,
      sellStatus: null,
      currencyFilter: null,
      fromAmount: null,
      fromNumber: null,
      fromDate: null,
      toAmount: null,
      toNumber: null,
      toDate: null,
      tag: null,
      category: null,
      branch: null,
      entrepot: null,
      lockStatus: null,
      registerar: null,
      payedStatus: null,
      fromTime: null,
      toTime: null,
      customFields: null,
      paginationLoading: false,
      showActionColumn: false,
    };
  },
  mixins: [General],
  mounted() {
    this.columnDefs = [
      {
        headerName: "#",
        colId: "rowNumber",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 70,
        maxWidth: 70,
        minWidth: 70,
        resizable: false,
        pinned: "right",
      },
      {
        headerName: this.$t("fileName"),
        field: "fileName",
        valueGetter: (params) => {
          if (params.data && params.data.DSW_FNAME && params.data.DSW_LNAME) {
            return params.data.DSW_FNAME + " " + params.data.DSW_LNAME;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 390,
        minWidth: 390,
        sortable: true,
      },
      {
        headerName: this.$t("fileType"),
        field: "fileType",
        valueGetter: (params) => {
          if (params.data && params.data.DSW_DD && params.data.DSW_DD !== null) {
            return params.data.DSW_DDD;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 210,
        minWidth: 210,
        sortable: true,
      },
      {
        headerName: this.$t("kb-size"),
        field: "kb-size",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.DSW_ROOZ && params.data.DSW_ROOZ !== null) {
            return params.data.DSW_ROOZZ;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 210,
        minWidth: 210,
        sortable: true,
      },
      {
        headerName: this.$t("date"),
        field: "date",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.DSW_MAH && params.data.DSW_MAH !== null) {
            return params.data.DSW_MAHH;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 210,
        minWidth: 210,
        sortable: true,
      },
      {
        headerName: this.$t("action"),
        field: "action",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.DSW_TOTL && params.data.DSW_TOTL !== null) {
            return params.data.DSW_TOTLL;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 200,
        minWidth: 200,
        sortable: true,
      },
    ];
  },
  watch: {
    callRefresh: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.getItems();
          this.$emit("initial-Loading-is", false);
        }
      },
    },
  },
  beforeMount() {
    this.getItems();
  },
  methods: {
    generateTime(val) {
      let format = "jYYYY/jMM/jDD";
      let date = val;
      if (!date) return null;
      return moment(date).locale("fa").format(format);
    },
    getItems(isPaginate = false) {
      var app = this;
      if (!isPaginate) {
        app.$emit("initial-Loading-is", true);
      }
      const id_ = app.$route.query.id;
      this.paginationLoading = isPaginate;
      app.$axios
        .get(app.$endpoint + "salary/insurance/" + id_, {
          params: {
            options: app.optionsNew,
          },
        })
        .then((response) => {
          app.rowData = [...response.data.$employee];
          app.totalRows = 1;
          app.lastPage = 1;
          app.$emit("workshop-items", {
            items: response.data.workshop,
          });
          app.$emit("employee-items", {
            items: response.data.$employee,
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
          app.paginationLoading = false;
        });
    },
    refreshData() {
      this.getItems(true);
    },
    updatePagination(value) {
      this.optionsNew.page = value;
      this.getItems(true);
    },
    updateItemPerPage(value) {
      this.optionsNew.itemsPerPage = value;
      this.optionsNew.page = 1;
      this.getItems(true);
    },
    editAction(rowData) {
      this.$router.push({
        name: "salery_operations_list",
        query: {
          id: rowData.id,
        },
      });
    },
    deleteAction(rowData) {
      var app = this;
      let salaryFactorConfigId = rowData.id;
      app.$axios
        .delete(app.$endpoint + "salary-factor-config/" + salaryFactorConfigId)
        .then((response) => {})
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          this.getItems(true);
          app.paginationLoading = false;
        });
    },
    goToDocuments(rowData, tab) {
      this.$router.push({
        name: "salary_documents",
        query: {
          id: rowData.id,
          tab: tab,
        },
      });
    },
  },
};
</script>

<style scoped>
.wrapperTable {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
::v-deep(.v-input .v-label.v-label--active) {
  top: 8px !important;
}
.v-skeleton-loader__list-item.v-skeleton-loader__bone {
  align-content: unset;
  align-items: flex-start;
  padding: 0;
}
.theme--light.v-skeleton-loader .v-skeleton-loader__text {
  background: rgb(146 139 139 / 12%);
}
.v-skeleton-loader__text {
  height: 30px;
}
.v-skeleton-loader__list-item {
  height: 41px;
}
</style>
